<template>
  <el-card :style="bodyStyle"
           shadow="never">
    <!-- 头部 -->
    <span style="font-size: 1rem">课程中心</span>
    <!-- 通知区域 -->
    <div class="notify-course-setting">
      <el-alert title="最新通知：无"
                type="success"
                :closable="false">
      </el-alert>
    </div>
    <!-- 课程区域 -->
    <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <!-- 课程 -->
      <el-tab-pane label="课程"
                   name="first">
        <el-button @click="creatNewCourse"
                   size="mini"
                   type="primary">新建课程</el-button>
        <!-- 筛选区域 -->
        <div style="height: 20px; background-color: grey; margin-top: 10px"></div>
        <!-- 课程专栏表格 -->
        <div v-loading="loading">
          <el-table :header-cell-style="courseRowClass"
                    :data="tableData"
                    style="width: 100%">
            <el-table-column label="名称"
                             width="auto">
              <template slot-scope="course_ietm">
                <div style="display: flex; zoom: 1">
                  <div>
                    <img style="height: 50px"
                         :src="course_ietm.row.course_cover"
                         alt="" />
                  </div>
                  <div>
                    <div style="margin-left: 10px">
                      {{ course_ietm.row.course_name }}
                    </div>
                    <div style="margin-left: 10px">
                      {{ course_ietm.row.course_price }} 元
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 课程树木 -->
            <el-table-column prop="name"
                             label="课程数"
                             width="80">
              <template slot="header">
                <div style="text-align: center">课程数</div>
              </template>
            </el-table-column>
            <el-table-column prop="operator"
                             label="操作"
                             width="auto">
              <template slot-scope="operator">
                <el-link @click="manageCourseConent(operator.row.course_id)"
                         :underline="false">内容管理</el-link>
                ｜<el-link @click="editCourse(operator.row)"
                         :underline="false">修改课程信息</el-link>
                ｜<el-link @click="manageCLub(operator.row)"
                         :underline="false">俱乐部管理</el-link>
                ｜<el-link @click="offLineCourse"
                         :underline="false">下线</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- 会员列表 -->
      <el-tab-pane label="会员管理"
                   name="second">
        <div>
          <el-select size="mini"
                     v-model="course_id"
                     placeholder="请选择">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 表格 -->
        <div v-loading="loading">
          <el-table :data="memberData"
                    style="width: 100%">
            <el-table-column prop="certificate_id"
                             label="ID"
                             width="180">
            </el-table-column>
            <el-table-column prop="name"
                             label="姓名"
                             width="180">
            </el-table-column>
            <el-table-column prop="course_name"
                             label="课程名称"
                             width="180">
            </el-table-column>
            <el-table-column prop="mobile"
                             label="联系电话"> </el-table-column>
            <el-table-column prop=""
                             label="操作">
              <template slot-scope="member">
                <el-link :underline="false">编辑</el-link>
                ｜
                <el-link @click="deleteMember(member.row)"
                         :underline="false">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <!-- 俱乐部管理 -->
      <!-- <el-tab-pane label="会员管理" name="club">俱乐部管理</el-tab-pane> -->

      <!-- 教练管理 -->
      <el-tab-pane label="教练管理"
                   name="third">
        <div style="margin-bottom: 20px">
          <el-button @click="addNewCoach"
                     size="mini"
                     type="primary">添加教练</el-button>
        </div>

        <!-- 教练表格 -->
        <div v-loading="loading">
          <el-table :header-cell-style="courseRowClass"
                    :data="coachData"
                    style="width: 100%">
            <el-table-column label="教练名称"
                             width="180">
              <template slot-scope="coach">
                {{ coach.row.coach_name }}</template>
            </el-table-column>
            <el-table-column prop="operator_name"
                             label="所属俱乐部"
                             width="180">
            </el-table-column>
            <el-table-column label="是否添加签名"
                             width="180">
              <template slot-scope="coach">
                <div style="text-align: left">
                  <div v-if="coach.row.is_signature">
                    <i class="el-icon-circle-check">已添加</i>
                  </div>
                  <div v-else><i class="el-icon-close">未添加</i></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="operator"
                             label="操作">
              <template slot-scope="coach">
                <el-link @click="manageCoach(coach.coach_id)"
                         :underline="false">查看</el-link>
                ｜<el-link :underline="false">编辑</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- 结束 -->
    </el-tabs>
  </el-card>
</template>

<script>
let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 150
import { tpx_app } from '../../network/request'
export default {
  name: 'course',
  data() {
    return {
      loading: true,
      // 卡片样式
      bodyStyle: `min-height: ${contentHeight}px`,
      activeName: 'first',
      tableData: [],
      coachData: [],
      // 会员筛选
      options: [
        {
          value: 1,
          label: '冲浪课程',
        },
      ],
      memberData: [],
      course_id: 1,
      certificate_id: '',
      mobile: '',
    }
  },
  created() {
    this.getCourseList()
  },
  mounted() {
    if (Object.keys(this.$route.query).length !== 0) {
      this.activeName = this.$route.query.tabname
      this.getCoachList()
    } else {
      this.activeName = 'first'
    }
  },
  methods: {
    // 删除会员和记录
    deleteMember(value) {
      this.$confirm('此操作将彻底删除该会员和记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .get(`/delete_course_member?member_id=${value.certificate_id}`)
            .then((res) => {
              if (res.data.errno == '0') {
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                })
              } else if (res.data.errno == '4002') {
                this.$message({
                  type: 'warning',
                  message: res.data.errmsg,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 添加新教练
    addNewCoach() {
      this.$router.push({ name: 'creat_new_coach' })
    },
    // 表头的样式
    courseRowClass() {
      return 'background-color:whitesmoke; '
    },
    // 获取课程列表
    getCourseList() {
      this.loading = true
      tpx_app({
        url: '/get_all_course',
      }).then((res) => {
        // console.log(res)
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.tableData = data
          this.loading = false
        } else {
          this.$message({
            message: errmsg,
            type: 'error',
          })
        }
      })
    },
    // 获取会员列表
    getMember() {
      tpx_app({
        url: `/get_member_list?course_id=${this.course_id}&certificate_id=${this.certificate_id}&mobile=${this.mobile}`,
      }).then((res) => {
        if (res.data.errno == '0') {
          // console.log(res.data.data);
          this.memberData = res.data.data
        }
      })
    },
    // 获取教练列表
    getCoachList() {
      tpx_app({
        url: '/get_course_coach',
      }).then((res) => {
        // console.log(res);
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.coachData = data
        }
      })
    },
    // 切换标签
    handleClick(tab) {
      if (tab.name == 'first') {
        this.getCourseList()
      } else if (tab.name == 'second') {
        this.getMember()
      } else if (tab.name == 'third') {
        this.getCoachList()
      }
    },
    // 内容管理
    manageCourseConent(value) {
      this.$router.push({
        name: 'course_content_manage',
        query: {
          course_id: value,
        },
      })
    },
    creatNewCourse() {
      this.$router.push({
        name: 'creat_new_courese',
        params: {
          componentName: '新建课程',
        },
        // query: {
        //   objectType: 1,
        //   infoId: id,
        // },
      })
      //   window.open(newpage.href, "_blank");
    },
    manageCLub(value) {
      this.$router.push({
        name: 'course_club_manage',
        params: {
          course: value,
        },
      })
    },
    editCourse(value) {
      // console.log(value);
      this.$router.push({
        name: 're_new_course',
        query: {
          course_item: value,
        },
      })
    },
    offLineCourse() {
      console.log('课程下线')
    },
    // 查看教练
    manageCoach() {},
  },
}
</script>

<style>
.notify-course-setting {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>